'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/dayFromNow.js